/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.97
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listCCBContractFees,
	listCCBContractFeesInit,
	listCCBContractFeesByAuthorizations,
	deleteCCBContractFees
} from '@api/house/CCBContractFees';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listCCBContractFees({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContractFees(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBContractFeesByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContractFeesByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listCCBContractFeesInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listCCBContractFeesInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBContractFees({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBContractFees({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
